/**
 * Main App Component
 * Handles routing and layout
 */

import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import DemoPage from './pages/DemoPage';
import HomePage from './pages/HomePage';
import SubscriptionPage from './pages/SubscriptionPage';
import AdminDashboard from './pages/Admin/AdminDashboard';
import EmbedPage from './pages/EmbedPage';
import ProtectedRoute from './components/ProtectedRoute';

// Marketing screenshot harness — DEV ONLY. Lazy + DEV-gated so the page (and the
// list of real outreach-target businesses + scripted conversations it renders) is
// eliminated from the production bundle, not just hidden from the router.
const ScreenshotPage = import.meta.env.DEV
    ? lazy(() => import('./pages/ScreenshotPage'))
    : null;

function App() {

    return (
        <div className="App">
            <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/subscription" element={<SubscriptionPage />} />
                <Route path="/demo/:brandSlug" element={<DemoPage />} />
                <Route path="/embed/:brandId" element={<EmbedPage />} />
                {import.meta.env.DEV && ScreenshotPage && (
                    <Route
                        path="/shot/:bizSlug"
                        element={<Suspense fallback={null}><ScreenshotPage /></Suspense>}
                    />
                )}

                {/* Admin Routes */}
                <Route
                    path="/admin/*"
                    element={
                        <ProtectedRoute>
                            <AdminDashboard />
                        </ProtectedRoute>
                    }
                />
            </Routes>
        </div>
    );
}

export default App;
